import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'getProperIconForType'
})
export class GetProperIconForTypePipe implements PipeTransform {

  transform(value:number) : string{
        if(value==0)
            return "./assets/interface/tacho.png"
        else
            return "./assets/interface/card.png"
    }

}
